import { ConcreteEncodable } from "./ConcreteEncodable";

import { UnsolicitedCancelLifeCycleEventImplEncoder } from "../../encoder/UnsolicitedCancelLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { UnsolicitedCancelLifeCycleEvent } from "../UnsolicitedCancelLifeCycleEvent";

export class UnsolicitedCancelLifeCycleEventImpl
  extends ConcreteEncodable
  implements UnsolicitedCancelLifeCycleEvent
{
  public static enType: string =
    "com.bcdfx.model.event.lifecycle.UnsolicitedCancelLifeCycleEventImpl";

  /*FID=1*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=2*/
  public id: string;
  /*FID=3*/
  public orders: Array<CubiqTS.OrderData> | null = null;
  /*FID=4*/
  public benchmarkFg: boolean;
  /*FID=5*/
  public sendToAltGrp: boolean;
  /*FID=6*/
  public alternateGroupId: CubiqTS.Long | null = null;
  /*FID=7*/
  public alternateGroupName: string;
  /*FID=8*/
  public makerName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UnsolicitedCancelLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(UnsolicitedCancelLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UnsolicitedCancelLifeCycleEventImpl[" +
      "eventTypeId=" +
      this.eventTypeId +
      "id=" +
      this.id +
      "orders=" +
      this.orders +
      "benchmarkFg=" +
      this.benchmarkFg +
      "sendToAltGrp=" +
      this.sendToAltGrp +
      "alternateGroupId=" +
      this.alternateGroupId +
      "alternateGroupName=" +
      this.alternateGroupName +
      "makerName=" +
      this.makerName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
